import { Skeleton } from 'aui';

export type SuspenseFallbackProps = {
  className?: string;
};

export function SuspenseFallback(props: SuspenseFallbackProps) {
  return <Skeleton className={props.className} />;
}
